import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { getHistoryRankingRewardsSuccess, getHistoryRankingRewardsFailed, GET_HISTORY_RANKING_REWARDS_START } from '~/views/app/redux/actions/pools';

const getHistoryRankingRewardsApi = (config) => {
  return api.get('/admin/pools/claim-history', config);
};

function* doGetHistoryRankingRewards(action) {
  try {
  
    const response = yield call(getHistoryRankingRewardsApi, action.payload);
    
    const numericKeys = Object.keys(response).filter(key => !isNaN(Number(key)));
    const historiesArray = numericKeys.map(key => ({
      ...response[key],
      key: response[key].txHash || key, 
    }));
    
    const { message, total, ...otherData } = response;
    
    const transformedResponse = {
      histories: historiesArray,
      total: total || historiesArray.length,
      message: message,
      ...otherData
    };
    
    yield put(getHistoryRankingRewardsSuccess(transformedResponse));
    if (action.onSuccess) {
      yield action.onSuccess(transformedResponse);
    }
  } catch (error) {
    yield put(getHistoryRankingRewardsFailed());
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchGetHistoryRankingRewards() {
  yield takeLatest(GET_HISTORY_RANKING_REWARDS_START, doGetHistoryRankingRewards);
}